import styled from 'styled-components';

import {breakpoints} from '../../constants/Breakpoints';

interface Props {
  desktopSrc: string;
  tabletSrc: string;
  mobileSrc: string;
}

const DownloadSelectionWrapper = styled.section<Props>`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  box-sizing: border-box;
  background-position: 70% 0;

  h1:nth-last-child(1) {
    filter: drop-shadow(2px 4px 8px #000080);
  }
  ${({desktopSrc}) => desktopSrc && `background-image: url(${desktopSrc});`}

  @media ${breakpoints.tablet} {
    ${({tabletSrc}) => tabletSrc && `background-image: url(${tabletSrc});`}
  }

  @media ${breakpoints.mobileL} {
    ${({mobileSrc}) => mobileSrc && `background-image: url(${mobileSrc});`}
    background-position: 65% 0;
  }
`;

export default DownloadSelectionWrapper;
